import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    // redirect: '/home',
    name: 'Home',
    component: () => import('../views/home.vue'),
    meta: { title: '紫金保险' },
  },
  {
    path: '/venueone',
    name: 'venueone',
    component: () => import('../views/venueone.vue'),
    meta: { title: '分会场一' },
  },
  {
    path: '/venuetwo',
    name: 'venuetwo',
    component: () => import('../views/venuetwo.vue'),
    meta: { title: '分会场二' },
  },
  {
    path: '/venuethree',
    name: 'venuethree',
    component: () => import('../views/venuethree.vue'),
    meta: { title: '分会场三' },
  },
]

const router = new VueRouter({
  routes,
  mode: 'history', // 去掉url中的#
})
router.afterEach((to) => {
  window.scrollTo(0, 0);
  /**
   * 判断路由元信息
   * 动态设置页面标题
   */
  if (to.matched.some((record) => record.meta.title)) {
    document.setTitle(to.meta.title);
  }
});

/**
 * 动态设置页面标题具体实现
 */
document.setTitle = function (title) {
  document.title = title;
};


export default router
